// Service layer para el rol admin — reportes de auditoria (Sprint 6 T9).
// Los tipos espejan 1:1 los dicts devueltos por backend/app/api/v1/reportes_admin.py.
import { api } from '../lib/api'

// ============================================================
// Tipos
// ============================================================
export interface DecisionJefeRow {
  sede_id: number
  sede_codigo: string
  sede_nombre: string
  aprobadas: number
  rechazadas: number
  expiradas: number
  total: number
  tiempo_respuesta_promedio_min: number | null
  ratio_aprobacion: number | null
}

export interface AlergiaFuenteRow {
  fuente: string
  total: number
  validadas_clinicamente: number
  contradichas: number
  activas: number
}

export interface SyncOdooRow {
  entidad_tipo: string
  estado: string
  total: number
  ultimo_evento: string | null
}

export interface RangoFechas {
  sede_id?: number | null
  fecha_inicio?: string | null // ISO datetime
  fecha_fin?: string | null
}

export type ExportKind = 'decisiones-jefes' | 'alergias-fuente' | 'sync-odoo'

// ============================================================
// Helpers
// ============================================================
function paramsLimpios(filtros: RangoFechas): Record<string, string | number> {
  const out: Record<string, string | number> = {}
  if (filtros.sede_id != null) out.sede_id = filtros.sede_id
  if (filtros.fecha_inicio) out.fecha_inicio = filtros.fecha_inicio
  if (filtros.fecha_fin) out.fecha_fin = filtros.fecha_fin
  return out
}

// ============================================================
// API client
// ============================================================
export const reportesAdminApi = {
  decisionesJefes: (filtros: RangoFechas = {}): Promise<DecisionJefeRow[]> =>
    api.get('/admin/reportes/decisiones-jefes', { params: paramsLimpios(filtros) })
      .then((r) => r.data),

  alergiasFuente: (filtros: RangoFechas = {}): Promise<AlergiaFuenteRow[]> =>
    api.get('/admin/reportes/alergias-fuente', { params: paramsLimpios(filtros) })
      .then((r) => r.data),

  syncOdoo: (filtros: RangoFechas = {}): Promise<SyncOdooRow[]> =>
    api.get('/admin/reportes/sync-odoo', { params: paramsLimpios(filtros) })
      .then((r) => r.data),

  /**
   * Descarga el CSV del reporte indicado y dispara un click en un <a>
   * descartable para forzar el "Save As" del navegador. Devuelve true si
   * el download arranco; lanza si el endpoint falla.
   */
  descargarExport: async (
    kind: ExportKind,
    filtros: RangoFechas = {},
  ): Promise<boolean> => {
    const resp = await api.get('/admin/reportes/export', {
      params: { kind, tipo: 'csv', ...paramsLimpios(filtros) },
      responseType: 'blob',
    })
    const blob = new Blob([resp.data], { type: 'text/csv;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `${kind}.csv`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
    return true
  },
}
